import React from 'react';
import Plot from "react-plotly.js";
import { Box, Paper, Typography, Divider } from "@mui/material";

const CampaignImpressionDayOfWeek = ({ data }) => {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    return (
        <Box mt={3}>
            {Object.entries(data).map(([billboardId, billboardData]) => {
                const weekdayData = billboardData.weekday_data || {};

                // Convert values to thousands and prepare data for box plot
                const boxPlotData = days.map(day => ({
                    y: (weekdayData[day] || []).map(val => val / 1000), // Convert to thousands
                    type: 'box',
                    name: day,
                    boxpoints: 'all',
                    jitter: 0.3,
                    pointpos: -1.8, // Match the reference component's point position
                    marker: {
                        color: '#f39c1c', // Match the reference component's color
                        size: 6
                    },
                    line: {
                        width: 1
                    }
                }));

                return (
                    <Paper
                        key={billboardId}
                        elevation={4}
                        sx={{
                            p: 3,
                            mb: 4,
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{ mb: 2, color: "primary.main", fontWeight: 600 }}
                        >
                            Billboard: {billboardId} - {billboardData.location} ({billboardData.height} x {billboardData.width})
                        </Typography>
                        <Divider sx={{ mb: 2 }} />

                        <Box sx={{ width: "100%" }}>
                            <Plot
                                data={boxPlotData}
                                layout={{
                                    boxmode: 'group',
                                    autosize: true,
                                    margin: { t: 50, l: 60, r: 30, b: 60 },
                                    yaxis: {
                                        title: "Impressions (thousands)",
                                        zeroline: false
                                    },
                                    xaxis: {
                                        title: "Day of the Week"
                                    },
                                    paper_bgcolor: "#fff",
                                    plot_bgcolor: "#fff",
                                    showlegend: false,
                                    height: 500
                                }}
                                useResizeHandler
                                style={{ width: "100%", height: "100%" }}
                                config={{
                                    responsive: true,
                                    displaylogo: false,
                                    displayModeBar: true
                                }}
                            />
                        </Box>
                    </Paper>
                );
            })}
        </Box>
    );
};

export default CampaignImpressionDayOfWeek;